/**
 * How long the most recent report query took, measured client-side around the running flag: it is
 * the wait the user actually saw, and it covers drills, whose responses carry no timings.
 */

import { useEffect, useRef, useState } from 'react';

export function useLoadDuration(running: boolean): number | undefined {
  const startedAt = useRef<number | undefined>(undefined);
  const [durationMs, setDurationMs] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (running) {
      startedAt.current = Date.now();
      return;
    }
    // Only a run that actually started yields a duration, so the panel stays hidden before the first
    // query instead of claiming a 0s load.
    if (startedAt.current === undefined) return;
    setDurationMs(Date.now() - startedAt.current);
    startedAt.current = undefined;
  }, [running]);

  return durationMs;
}
